module.exports = __webpack_public_path__ + "static/media/miniV5Gyro.b68c607d.png";